(ns teamoesterreich.lebensretter-mode.todos
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.link :refer [link]]
            [reagent-material-ui.icons.person :refer [person]]
            [reagent-material-ui.icons.phone-iphone :refer [phone-iphone]]
            [reagent.core :as r]
            [teamoesterreich.lebensretter-checks :as h-check]
            [teamoesterreich.lebensretter-mode.status-identity :refer [status-identity]]
            [teamoesterreich.lebensretter-mode.other-documents :refer [other-documents]]
            [teamoesterreich.lebensretter-mode.status-qualification :refer [status-qualification status-qualification-extend]]
            [teamoesterreich.store :as store]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.modal.info-popup :as info-popup]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.config :as config]
            [teamoesterreich.util.log :as log]))


(defn fbDate-2-local-date [fb-date]
  (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds ^js fb-date)))))

(defn select-lr-type-source [!actual-user]
  (let [old-type (or (get-in @!actual-user [:lrClearance-type]) "keine besondere Qualifikation")
        old-source (or (get-in @!actual-user [:lr-source]) "")
        !st (r/atom {:type old-type :source old-source})
        !type (r/cursor !st [:type])
        !source (r/cursor !st [:source])]
    (fn []
      [mui/grid
       {:container false
        :item      true
        :md        12                                       ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :style     #js {:padding "15px"}
        }
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "left"
         :alignItems "flex-start"
         :spacing    4
         }

        [mui/grid
         {:container false
          :item      true
          :xs        6
          }
         [mui/form-label "Ich bin in folgender Organisation tätig"
          [mui/select
           {
            :style     {:backgroundColor (if (not= old-source @!source) "#ffd6d2" "#ffffff")}
            :fullWidth true
            :value     @!source
            :onChange  (fn [e]
                         (reset! !source (h/event-value e))
                         )}

           [mui/menu-item {:value "" :key ""} ""]
           [mui/menu-item {:value "Rotes Kreuz" :key "Rotes Kreuz"} "Rotes Kreuz"]
           [mui/menu-item {:value "Polizei" :key "Polizei"} "Polizei"]
           [mui/menu-item {:value "Feuerwehr" :key "Feuerwehr"} "Feuerwehr"]
           [mui/menu-item {:value "Bergrettung" :key "Bergrettung"} "Bergrettung"]
           [mui/menu-item {:value "Wasserrettung" :key "Wasserrettung"} "Wasserrettung"]
           [mui/menu-item {:value "OEGK" :key "OEGK"} "Österreichische Gesundheitskasse"]
           ]]]
        (when (or (not= old-source @!source) (not= old-type @!type))
          [mui/grid
           {:container false
            :item      true
            :xs        4
            } [mui/button
               {:variant "outlined"
                :color   "secondary"

                :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}
                :onClick #(a/set-user-details {:lrClearance-type @!type
                                               :lr-source        @!source})
                }
               "Speichern"]])
        ]])))



(defn lr-button [!app-link]
  (when (nil? @!app-link)
    (reset! !app-link :loading)
    (a/get-lebensretter-link (fn [link]
                               (log/out link)
                               (reset! !app-link link))))
  (if (and @!app-link (not= @!app-link :loading))
    [mui/button {:variant   "outlined"
                 :color     "secondary"
                 :component "a"
                 :href      @!app-link
                 :target    "_blank"
                 :startIcon (r/as-element [link])}
     "Link öffnen"]
    [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 20} "lade..."]))

(defn lr-sb-button [!sb-link]
  (when (nil? @!sb-link)
    (reset! !sb-link :loading)
    (a/get-lebensretter-selfexplain-link (fn [link]
                                           (log/out link)
                                           (reset! !sb-link link))))
  (if (and @!sb-link (not= @!sb-link :loading))
    [mui/button {:variant   "outlined"
                 :color     "secondary"
                 :component "a"
                 :href      @!sb-link
                 :startIcon (r/as-element [link])}
     "Zur Selbsterklärung"]
    [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 20} "lade..."]))

(defn info-part [!actual-user switch-page]
  [:<>
   [mui/grid
    {:container false
     :item      true
     :xs        12                                          ;extra-small: 0px
     :style     {:padding "15px"}}
    [:h1
     "Voraussetzungen"]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-profile? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      "Vollständig ausgefülltes Profil"
      [:br]
      (when-not (h-check/check-profile? @!actual-user)
        [mui/typography {:color "error" :variant "body2"} "Es fehlt: " (:profile-incomplete-hint @!actual-user)])]
     [mui/button {:variant   "outlined" :color "primary"
                  :startIcon (r/as-element [person])
                  :onClick   #(switch-page :profile)}
      "Zu meinem Profil"]]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-email? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      "Email validiert"]]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-handy? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      "Handynummer validiert"]]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-lr-app? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      (txt/txt :helping "Lebensretter App installiert")]]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-identity? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      "Identität bestätigt"]]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-age? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      "Alter > 18 Jahre"]]

    [:div {:class "helping-check-line"}
     [:div {:class "check-line-icon"}
      (if (h-check/check-activated? @!actual-user) [check] [close])]
     [:div {:class "check-line-text"}
      "Freigabe durch Bearbeiter"]]]

   [mui/grid
    {:container false
     :item      true
     :md        12                                          ;medium: 960px
     :xs        12                                          ;extra-small: 0px
     :style     #js {:padding "15px"}}
    [mui/button
     {:variant  "outlined"
      :color    "secondary"
      :style    #js {:margin "10px 0 10px 10px" :min-width "200px"}
      :disabled (or (nil? (:birthday @!actual-user)) (not (h-check/check-age? @!actual-user)))
      :onClick  #(a/set-user-details {:request-lebensretter true :status-lebensretter true})}
     "Ich will mitmachen."]
    ;[:div (pr-str @!actual-user)]
    (cond
      (nil? (:birthday @!actual-user))
      [mui/typography {:color   "error"
                       :variant "body2"}
       "Du musst zuerst in deinem Profil dein Geburtsdatum eintragen"]

      (not (h-check/check-age? @!actual-user))
      [mui/typography {:color   "error"
                       :variant "body2"}
       "Du musst 18 Jahre alt sein, um dich als Lebensretter:in anzumelden"]
      )
    ]
   ])




(defn special-qualification-rs []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Rettungssanitäter:in"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben Rettungssanitäterin/Rettungssanitäter zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch:"
                          [:br] " (zum Beispiel: Prüfungszeugnis, Dienstausweis, letzter Rezertifizierungsnachweis, ...)"]]
   ])

(defn special-qualification-nfs []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Notfallsanitäter_in (NFS/NKA/NKV/NKI)"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben, Notfallsanitäterin/Notfallsanitäter." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch:"
                          [:br] " (zum Beispiel: Prüfungszeugnis, Dienstausweis, letzter Rezertifizierungsnachweis, ...)"]]
   ])
(defn special-qualification-na []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Notärztin/Notarzt"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben aktive Notärztin/Notarzt zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch:"
                          [:br] " (zum Beispiel: Notarztdiplom, Fortbildungsnachweis)"]]])
(defn special-qualification-dr []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Ärztin/Arzt"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben Ärztin/Arzt zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch:"
                          [:br] " (zum Beispiel: Ärzteausweis)"]]])
(defn special-qualification-mountain []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Bergrettung"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben, bei der Bergrettung aktiv zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Qualifikations Nachweis hoch: "
                          [:br] " (zum Beispiel: Dienstausweis, Zeugnis)"]]])

(defn special-qualification-water []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Wasserrettung"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben, bei der Wasserrettung aktiv zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Qualifikations Nachweis hoch: "
                          [:br] " (zum Beispiel: Dienstausweis, Zeugnis)"]]])

(defn special-qualification-cave []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Höhlenrettung"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben, bei der Höhlenrettung aktiv zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Qualifikations Nachweis hoch: "
                          [:br] " (zum Beispiel: Dienstausweis, Zeugnis)"]]])

(defn special-qualification-police []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Polizei"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben, Polizistin/Polizist zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch: "
                          [:br] " (zum Beispiel: Dienstausweis)"]]])

(defn special-qualification-fire []
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Feuerwehr"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben aktives Mitglied der Feuerwehr zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]

   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch: "
                          [:br] " (zum Beispiel: Dienstausweis)"]]])

(defn special-qualification-nurse [!sb-link]
  [:<>
   [:h3 "Nachweis besonderer Qualifikation: Pflegepersonal"]
   [:div {:class "check-line-text"}
    "Du hast in deiner Selbsterklärung angegeben Pflegepersonal zu sein." [:br]
    "Wenn du uns einen Nachweis hochlädst, kannst du aufgrund deiner Qualifikation regional höhere Alarmierungsradien oder Priorisierung erhalten."
    ]
   [status-qualification [:div {:class "check-line-text"} "Bitte lade einen Nachweis hoch: "
                          [:br] " (zum Beispiel: Zeugnis)"]]])


(defn get-it [switch-page]
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !userId (r/atom 1)
        !state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !hide-info (r/cursor store/app-state [:hide-info])
        !app-link (r/cursor store/app-state [:lr-app-link])
        !sb-link (r/cursor store/app-state [:lr-sb-link])
        !request-lebensretter (r/cursor store/app-state [:actual-user :request-lebensretter])
        !info-popup-message (r/cursor store/app-state [:info-popup])]
    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "10px"}}
     [info-popup/info-modal !info-popup-message "Ok" (fn [])]
     [mui/grid
      {:container false
       :item      true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1}
        [mui/grid
         {:container false
          :item      true
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}}
         [:h1 "Lebensretter:in"]
         [:p {:dangerouslySetInnerHTML {:__html (txt/txt :helping "Lebensretter-Kachel")}}]
         [:a {:href (str (txt/txt :helping "Lebensretter-Doku.pdf")) :target "_blank"} "--> Link zum Infoblatt"]]



        (cond

          @!request-lebensretter
          [:<>


           [mui/grid
            {:container false
             :item      true
             :md        12                                  ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     #js {:padding "15px"}}
            [mui/button
             {:variant  "outlined"
              :color    "secondary"
              :disabled "disabled"
              :style    #js {:margin "10px 0 10px 10px" :min-width "200px"}}
             "Ich helfe schon"]]

           [mui/grid
            {:container false
             :item      true
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "15px"}}

            (if (= "toe" config/CLIENT) [(select-lr-type-source !actual-user)])
            ;[:div (pr-str @!actual-user)]

            [:h2 "Meine Freischaltung"]
            (if (:status-lebensretter @!actual-user)
              [:<>
               [:center [:h3 {:style {:color "darkgreen" :border "2px solid darkgreen" :margin-bottom "60px"}}
                         "Freigeschaltet als `LEBENSRETTER:IN` "
                         (when (:status-lebensretter-valid-until @!actual-user)
                           (str "bis " (fbDate-2-local-date (:status-lebensretter-valid-until @!actual-user))))]]

               (when (h-check/in-6-month? (:status-lebensretter-valid-until @!actual-user))
                 [:<>
                  [:center [:h3 {:style {:color "#be5c00" :border "2px solid #be5c00" :margin-bottom "60px"}}
                            "Diese Freischaltung läuft bald aus!"]]
                  [:div {:class "helping-check-line" :style {:margin-top "10px"}}
                   [:div {:class "check-line-icon"}]
                   [:div {:class "check-line-text"}
                    "zum Verlängern fülle die Selbsterklärung erneut aus."]
                   [:div {:class "check-line-buttons"}
                    [lr-sb-button !sb-link]]]])

               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"} [info]]
                [:div {:class "check-line-text"}
                 (txt/txt :helping "Lebensretter App installiert")
                 " und mit diesem Account verbunden"
                 [:br]
                 (when (h-check/check-lr-app? @!actual-user)
                   [:span {:style {:color "darkgreen"}} "Du hast bereits mindestens eine verknüpfte App!"])
                 [:br]
                 [:b {:style {:color "#a22525"}}
                  "Wichtig! Dieser Link verbindet die Lebensretter App mit Deinem Account."
                  [:br]
                  "Danach sollte dein Name in der App stehen."]]
                [:div {:class "check-line-buttons"}
                 [lr-button !app-link]

                 [mui/button {:variant   "outlined"
                              :color     "primary"
                              :startIcon (r/as-element [email])
                              :onClick   (fn [] (a/send-lebensretter-link #(reset! !info-popup-message "Email wurde gesendet!")))}
                  "Link per Mail zusenden"]]]

               ]

              [:<>
               [:center [:h3 {:style {:color "red" :border "2px solid red" :margin-bottom "60px"}} "Lebensretter:in noch nicht freigeschaltet"]]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"} [info]]
                [:div {:class "check-line-text"}

                 (txt/txt :helping "Lebensretter App installiert")
                 " und mit diesem Account verbunden"
                 [:br]
                 (when (h-check/check-lr-app? @!actual-user)
                   [:span {:style {:color "darkgreen"}} "Du hast bereits mindestens eine verknüpfte App!"])
                 [:br]
                 [:b {:style {:color "#a22525"}}
                  "Wichtig! Dieser Link verbindet die Lebensretter App mit Deinem Account."
                  [:br]
                  "Danach sollte dein Name in der App stehen."]]
                [:div {:class "check-line-buttons"}
                 [lr-button !app-link]

                 [mui/button {:variant   "outlined"
                              :color     "primary"
                              :startIcon (r/as-element [email])
                              :onClick   (fn [] (a/send-lebensretter-link #(reset! !info-popup-message "Email wurde gesendet!")))}
                  "Link per Mail zusenden"]]]

               (when-not (h-check/check-profile? @!actual-user)
                 [:div {:class "helping-check-line"}
                  [:div {:class "check-line-icon"} [close]]
                  [:div {:class "check-line-text"}
                   "Vollständig ausgefülltes Profil"
                   [:br]
                   [mui/typography {:color "error" :variant "body2"} "Es fehlt: " (:profile-incomplete-hint @!actual-user)]]
                  [:div {:class "check-line-buttons"}
                   (when-not (h-check/check-profile? @!actual-user)
                     [mui/button {:variant   "outlined" :color "primary"
                                  :startIcon (r/as-element [person])
                                  :onClick   #(switch-page :profile)}
                      "Zu meinem Profil"])]])

               (when-not (h-check/check-email? @!actual-user)
                 [:div {:class "helping-check-line"}
                  [:div {:class "check-line-icon"}
                   [close]]
                  [:div {:class "check-line-text"}
                   "Email validiert"]
                  [:div {:class "check-line-buttons"}
                   [mui/button {:variant   "outlined" :color "primary"
                                :startIcon (r/as-element [email])
                                :onClick   #(a/verify-phone-number)}
                    "Zur Validierung"]
                   ]])

               (when-not (h-check/check-handy? @!actual-user)
                 [:div {:class "helping-check-line"}
                  [:div {:class "check-line-icon"} [close]]
                  [:div {:class "check-line-text"}
                   "Handynummer validiert"]
                  [:div {:class "check-line-buttons"}

                   [mui/button {:variant   "outlined" :color "primary"
                                :startIcon (r/as-element [phone-iphone])
                                :onClick   #(a/verify-phone-number)}
                    "Zur Validierung"]
                   ]])

               (when-not (h-check/check-age? @!actual-user) ;
                 [:div {:class "helping-check-line"}
                  [:div {:class "check-line-icon"}
                   [close]]
                  [:div {:class "check-line-text"}
                   "Alter > 18 Jahre "]])

               (when-not (h-check/check-identity? @!actual-user)
                 [(status-identity)])

               (when-not (h-check/check-selfexplain? @!actual-user)
                 [:div {:class "helping-check-line" :style {:margin-top "10px"}}
                  [:div {:class "check-line-icon"}
                   [close]]
                  [:div {:class "check-line-text"}
                   "Unterschriebene Selbsterklärung"]
                  [:div {:class "check-line-buttons"}
                   [lr-sb-button !sb-link]]])

               (when-not (h-check/check-activated? @!actual-user)
                 [:div {:class "helping-check-line"}
                  [:div {:class "check-line-icon"}
                   [close]]
                  [:div {:class "check-line-text"}
                   "Freigabe durch Bearbeiter:in"]])])

            (if (= "toe" config/CLIENT)
              [:<>


               (when (and (h-check/check-selfexplain? @!actual-user)
                          (or
                            (= (get-in @!actual-user [:lrClearance-type]) "RS")
                            (= (get-in @!actual-user [:lrClearance-type]) "NFS")
                            (= (get-in @!actual-user [:lrClearance-type]) "NKA")
                            (= (get-in @!actual-user [:lrClearance-type]) "NKI")
                            (= (get-in @!actual-user [:lrClearance-type]) "NKV")
                            (= (get-in @!actual-user [:lrClearance-type]) "DR")
                            (= (get-in @!actual-user [:lrClearance-type]) "NA")
                            (= (get-in @!actual-user [:lrClearance-type]) "PF")
                            (= (get-in @!actual-user [:lrClearance-type]) "PO")
                            (= (get-in @!actual-user [:lrClearance-type]) "FW")
                            (= (get-in @!actual-user [:lrClearance-type]) "BR")
                            (= (get-in @!actual-user [:lrClearance-type]) "WR")
                            (= (get-in @!actual-user [:lrClearance-type]) "HR")))
                 [:<>
                  [:h2 "Besondere Qualifikation"]
                  [:div {:class "helping-check-line" :style {:margin-top "10px"}}
                   [:div {:class "check-line-icon"}]
                   [:div {:class "check-line-text"}
                    "Um deine Qualifikation zu ändern, fülle bitte die Selbsterklärung erneut aus."]
                   [:div {:class "check-line-buttons"}
                    [lr-sb-button !sb-link]]]])

               (case (or (get-in @!actual-user [:lrClearance-type]) "")
                 ""
                 [:<>
                  [:p
                   "Wenn du einer dieser Gruppen angehörst kannst du regional höhere Alarmierungsradien oder Priorisierung erhalten." [:br]
                   "Bitte gib eine solche in der Selbsterklärung an."]
                  [:div {:class "helping-check-line"}
                   [:div {:class "check-line-text"}
                    [:ul
                     [:li "Aktives Rettungsdienstpersonal (ehren- und hauptamtlich) oder"]
                     [:li "Ärztin/Arzt oder"]
                     [:li "Pflegepersonal oder"]
                     [:li "Polizist/Polizistin oder"]
                     [:li "Feuerwehr oder"]
                     [:li "Mitglied der Bergrettung, Wasserrettung, Höhlenrettung"]
                     ]
                    ]]
                  ]

                 "RS"
                 [special-qualification-rs !state !userId]

                 "NFS"
                 [special-qualification-nfs !state !userId]
                 "NKA"
                 [special-qualification-nfs !state !userId]
                 "NKV"
                 [special-qualification-nfs !state !userId]
                 "NKI"
                 [special-qualification-nfs !state !userId]
                 "NA"
                 [special-qualification-na !state !userId]
                 "DR"
                 [special-qualification-dr !state !userId]
                 "FW"
                 [special-qualification-fire !state !userId]

                 "PO"
                 [special-qualification-police !state !userId]

                 "BR"
                 [special-qualification-mountain !state !userId]

                 "HR"
                 [special-qualification-cave !state !userId]

                 "WR"
                 [special-qualification-water !state !userId]

                 "PF"
                 [special-qualification-nurse !state !userId]

                 [:<>
                  [:h2 "Besondere Qualifikation"]

                  [:div {:class "helping-check-line"}
                   [:div {:class "check-line-text"}

                    [:ul
                     [:li "Aktives Rettungsdienstpersonal (ehren- und hauptamtlich) oder"]
                     [:li "Ärztin/Arzt oder"]
                     [:li "Pflegepersonal oder"]
                     [:li "Polizist/Polizistin oder"]
                     [:li "Feuerwehr oder"]
                     [:li "Mitglied der Bergrettung, Wasserrettung, Höhlenrettung"]
                     ]
                    [:p
                     "Wenn du einer dieser Gruppen angehörst kannst du regional höhere Alarmierungsradien oder Priorisierung erhalten." [:br]
                     [:strong "Bitte gib eine solche in der Selbsterklärung an."]

                     ]
                    ]
                   [:div {:class "check-line-buttons"}
                    [lr-sb-button !sb-link]
                    ]]

                  ]
                 )

               (when (and (:status-lebensretter @!actual-user) (not= (get-in @!actual-user [:lrClearance-type]) "EH"))
                 (if (and (get-in @!actual-user [:status-lebensretter-qualification-valid]) (h-check/in-future? (get-in @!actual-user [:status-lebensretter-qualification-until])))
                   [:<>

                    [:center [:h3 {:style {:color "darkgreen" :border "2px solid darkgreen"}} "Qualifikation freigeschaltet bis " (fbDate-2-local-date (get-in @!actual-user [:status-lebensretter-qualification-until]))]]

                    (when (h-check/in-6-month? (:status-lebensretter-qualification-until @!actual-user))
                      [:<>
                       [:center [:h3 {:style {:color "#be5c00" :border "2px solid #be5c00" :margin-bottom "40px"}}
                                 "Diese Qualifikation läuft bald aus!"]]

                       [status-qualification-extend [:div {:class "check-line-text"} "zum Verlängern lade bitte ein neues Qualifikations-Dokument hoch."
                                                     [:br] " (zum Beispiel: Dienstausweis, Zeugnis)"]]
                       ])

                    ]



                   [:center [:h3 {:style {:color "darkred" :border "2px solid darkred"}} "Qualifikation noch nicht freigeschaltet"]]))






               [:br]


               [:br]

               ])

            [:div
             [other-documents]
             ]



            [:br]


            (when false
              [:<>
               [:h2 "Info First-Responder"]
               [:center [:h3 {:style {:color "darkgreen" :border "2px solid darkgreen"}} "Als First Responder freigeschaltet"]]

               ])

            ]]

          :else
          [info-part !actual-user switch-page])
        ]]]]))


